<template>
  <div
    v-show="basligGoster"
    :class="['app-card sb-alan mb-3 sm:mb-4 p-3 sm:p-5 rounded-[12px] flex flex-wrap items-center gap-x-3 gap-y-2', genislikSinifi]"
  >
    <Button
      v-if="geriHedefi"
      type="button"
      class="sb-geri shrink-0"
      icon="pi pi-arrow-left"
      severity="secondary"
      outlined
      aria-label="Geri"
      @click="geriTikla"
    />
    <span
      v-if="sayfaIkonu"
      class="hidden sm:inline-flex items-center justify-center w-10 h-10 rounded-lg bg-primary text-primary-contrast shrink-0"
      aria-hidden="true"
    >
      <i :class="sayfaIkonu" class="text-lg"></i>
    </span>
    <!-- MD-2: dar ekranda tek satır — başlık kalan yeri alır, sığmazsa «…» (tam metin title'da) -->
    <div class="flex flex-col min-w-0 max-sm:flex-1">
      <nav v-if="yolIzi.length" aria-label="Yol izi" class="hidden sm:block">
        <ol class="flex flex-wrap items-center gap-1 text-sm text-gray-500 dark:text-gray-400">
          <li v-for="(h, i) in yolIzi" :key="i" class="flex items-center gap-1">
            <span v-if="i > 0" aria-hidden="true">›</span>
            <router-link v-if="h.url" :to="h.url" class="hover:underline">{{ h.label }}</router-link>
            <span v-else>{{ h.label }}</span>
          </li>
        </ol>
      </nav>
      <!-- Yardım düğmesi başlık satırında: yol izi + başlık bloğunun ortasına değil başlığın
           hizasına oturur. -->
      <div class="flex items-center gap-1 min-w-0">
        <span class="text-xl sm:text-2xl font-bold text-gray-900 dark:text-gray-100 max-sm:truncate max-sm:text-lg" :title="baslikMetni">{{ baslikMetni }}</span>
        <!-- BSL §8 «? menüsü»: sayfada tur ya da yardım varsa görünür; menü: Bu ekranı tanıt /
             Sayfa yardımı / Başlarken listesi. Yalnız yardım varsa (BSL görünmüyor) doğrudan yardım. -->
        <Button
          v-if="yardimGoster || turAnahtari"
          id="sb-yardim"
          type="button"
          label="Yardım"
          icon="pi pi-question-circle"
          text
          class="shrink-0 renk-bilgi"
          aria-label="Yardım"
          aria-haspopup="true"
          @click="yardimTikla"
        />
        <Menu ref="yardimMenu" :model="yardimMenuOgeleri" :popup="true" />
      </div>
    </div>
    <!-- KDU K8: sayfada kirli form (route, sekme çocuğu ya da açık Dialog) varken "Kaydedilmedi".
         Sarmalayıcı hep DOM'da (aria-live bölgesi önceden var olmalı); temizken sr-only → flex
         boşluğu (gap) eklemez. -->
    <span :class="kirli ? 'inline-flex items-center' : 'sr-only'" aria-live="polite">
      <Tag v-if="kirli" class="sb-kirli" severity="warn" value="Kaydedilmedi" icon="pi pi-pencil" />
    </span>
    <span id="sb-etiket" class="flex items-center gap-2"></span>
    <span class="flex-1 max-sm:hidden"></span>
    <span id="sb-eylem" class="flex flex-wrap items-center gap-2 justify-end"></span>
    <!-- MD-2: bağlam (şube seçici) dar ekranda başlığın altında ince ikinci satır; masaüstünde boş -->
    <div id="sb-baglam" class="basis-full flex items-center gap-2 empty:hidden sm:hidden"></div>
  </div>
  <YardimPaneli v-model="yardimPaneliAcik" :anahtar="yardimAnahtariDeger" />
</template>

<script>
import { uiState } from "@/services/uiState";
import { ustYolu, geriGit, geriHedefi } from "@/services/geriNavigasyon";
import { yardimAnahtari } from "@/services/yardim";
import { kirliVarMi } from "@/services/kirliKayit";
import YardimPaneli from "./YardimPaneli.vue";
import { bsl, pencereAc, turIste } from "@/baslarken/durum";
import { yolunTuru } from "@/baslarken/turlar";
import { yolunModulHatti } from "@/baslarken/hatlar";

// Layout parçası — AdminLayout.vue'da <router-view>'ün üstüne konur. Kendi gosterilenRoute'unu
// tutar: out-in geçişte eski sayfa DOM'dan çıkana kadar $route zaten değişmiş olabilir, bu
// yüzden component DEĞİŞEN gezinmelerde AdminLayout'un transition @before-enter'ı routeGuncelle()
// ile besler; component DEĞİŞMEYEN gezinmelerde (yalnız query/param) $route watch'ı yeterli.
// bkz. Dokumanlar/Arayuz/SAYFA-BASLIGI-PLANI.md §3.2, §12 (SB5: başlık kartı + menü ikonu).

// Menü ağacında (items → items → items) url'i route path'ine eşit olan öğeyi, kökten başlayan
// ataları ("ata") ile birlikte bulur; önek eşleşmesi yapmaz (kısa URL'li bir öğe ilgisiz alt
// sayfalara ikon/yol izi vermesin diye, karar 28). SB7: sayfaIkonu ve yolIzi aynı fonksiyonu kullanır.
function menuYoluBul(liste, yol, ata = []) {
  if (!Array.isArray(liste)) return null;
  for (const oge of liste) {
    if (oge.separator) continue;
    if (oge.url && oge.url.split("?")[0] === yol) return { oge, ata };
    if (Array.isArray(oge.items)) {
      const bulunan = menuYoluBul(oge.items, yol, [...ata, oge]);
      if (bulunan) return bulunan;
    }
  }
  return null;
}

export default {
  name: "SayfaBasligiAlani",
  components: { YardimPaneli },
  props: {
    menu: { type: Array, default: () => [] },
  },
  data() {
    return {
      gosterilenRoute: this.$route,
      yardimPaneliAcik: false,
      turSekmede: null, // BSL-D2 (B-9): menü açılırken açık sekmenin turu (yoksa «Bu ekranı tanıt» yok)
      bsl,
    };
  },
  computed: {
    basligGoster() {
      return this.gosterilenRoute.meta.baslik !== false;
    },
    // KDU K8: defter reaktif (services/kirliKayit.js), her kayıt bileşenin computed kirliMi'sini
    // okur — ek olay yok; kaydet/Vazgeç/unmount/dialog kapanınca rozet kendiliğinden düşer.
    kirli() {
      return kirliVarMi();
    },
    baslikMetni() {
      return uiState.sayfaBasligi.baslik || this.gosterilenRoute.meta.title;
    },
    // GBH: menü sayfaları dahil her başlıkta; geçmişsiz açılışta üst sayfa ya da Anasayfa.
    geriHedefi() {
      return geriHedefi(this.gosterilenRoute, "/admin/main", uiState.sayfaBasligi.geriYedek);
    },
    yardimGoster() {
      if (uiState.yardimListesiHata) return true;
      if (!Array.isArray(uiState.yardimliSayfalar)) return false;
      return !!yardimAnahtari(this.gosterilenRoute.path, uiState.yardimliSayfalar);
    },
    // BSL: tur yalnız Başlarken görünen (lisanslı, sağlayıcı olmayan) şirkette sunulur.
    turAnahtari() {
      if (!bsl.durum || bsl.durum.Gizli) return null;
      return yolunTuru(this.gosterilenRoute.path);
    },
    yardimMenuOgeleri() {
      const ogeler = [];
      if (this.turSekmede) {
        const anahtar = this.turSekmede;
        ogeler.push({ label: "Bu ekranı tanıt", icon: "pi pi-directions", command: () => this.menuKapatVe(() => turIste(anahtar)) });
      }
      if (this.yardimGoster) {
        ogeler.push({ label: "Sayfa yardımı", icon: "pi pi-book", command: () => this.menuKapatVe(() => { this.yardimPaneliAcik = true; }) });
      }
      if (bsl.durum && !bsl.durum.Gizli) {
        ogeler.push({
          label: "Kurulum adımları",
          icon: "pi pi-flag",
          command: () => this.menuKapatVe(() => pencereAc(yolunModulHatti(this.gosterilenRoute.path) || "ANA")),
        });
      }
      return ogeler;
    },
    yardimAnahtariDeger() {
      if (uiState.yardimListesiHata) return this.gosterilenRoute.path;
      if (!Array.isArray(uiState.yardimliSayfalar)) return null;
      return yardimAnahtari(this.gosterilenRoute.path, uiState.yardimliSayfalar);
    },
    genislikSinifi() {
      const g = this.gosterilenRoute.meta.icerikGenisligi;
      return g ? [g, "mx-auto"] : null;
    },
    sayfaIkonu() {
      const bul = (yol) => {
        if (!yol) return null;
        const bulunan = menuYoluBul(this.menu, yol);
        return bulunan ? bulunan.oge.icon : null;
      };
      let icon = bul(this.gosterilenRoute.path);
      if (!icon) {
        const ust = ustYolu(this.gosterilenRoute);
        const ustYolStr = typeof ust === "string" ? ust.split("?")[0] : ust && ust.path;
        icon = bul(ustYolStr);
      }
      return icon && /\bpi-[\w-]+/.test(icon) ? icon : null;
    },
    // SB7 karar 33: menüdeki üst gruplar, alt sayfada üst sayfanın kendisi de - sayfa adı
    // (baslikMetni'nde zaten var) tekrar edilmez. Menüde bulunamayan sayfada boş dizi döner.
    yolIzi() {
      const halkaYap = (oge) => ({ label: oge.label, url: oge.url ? oge.url.split("?")[0] : null });
      const kendi = menuYoluBul(this.menu, this.gosterilenRoute.path);
      if (kendi) return kendi.ata.map(halkaYap);
      const ust = ustYolu(this.gosterilenRoute);
      const ustYolStr = typeof ust === "string" ? ust.split("?")[0] : ust && ust.path;
      const ustBulunan = ustYolStr ? menuYoluBul(this.menu, ustYolStr) : null;
      return ustBulunan ? [...ustBulunan.ata, ustBulunan.oge].map(halkaYap) : [];
    },
  },
  watch: {
    $route(yeni, eski) {
      const yeniKayit = yeni.matched[yeni.matched.length - 1];
      const eskiKayit = eski.matched[eski.matched.length - 1];
      if (yeniKayit === eskiKayit) {
        this.gosterilenRoute = yeni;
      }
    },
  },
  methods: {
    // BSL-D1 (S-8): ? menüsü tur/pencere karartmasının üstünde kalmasın — önce kapanır, iş sonra başlar.
    menuKapatVe(is) {
      if (this.$refs.yardimMenu) this.$refs.yardimMenu.hide();
      this.$nextTick(is);
    },
    routeGuncelle(route) {
      this.gosterilenRoute = route;
    },
    yardimTikla(olay) {
      this.turSekmede = this.turAnahtari ? yolunTuru(this.gosterilenRoute.path, true) : null;
      if (this.yardimMenuOgeleri.length <= 1 && this.yardimGoster) {
        this.yardimPaneliAcik = true;
        return;
      }
      this.$refs.yardimMenu.toggle(olay);
    },
    geriTikla() {
      geriGit(this.$router, this.gosterilenRoute, uiState.sayfaBasligi.geriYedek, "/admin/main");
    },
  },
};
</script>

<style scoped>
/* SB §3.1: yazdırmada gizlenir (Teklif PDF). html2pdf/html2canvas print medyasını tetiklemediği
   için PDF çıktısını etkilemez, yalnız gerçek tarayıcı yazdırmasında (Ctrl+P) devre dışı kalır. */
@media print {
  .sb-alan {
    display: none !important;
  }
}

/* Rozet (karar 15/25): teleport edilen Tag'ler DOM'da .sb-alan altında olduğu için :deep ile
   kapsanır. Çerçeve ve yazı aynı ton, WCAG 1.4.11 ≥3:1 için -700/-300 seçildi (plan §12.3). */
.sb-alan :deep(#sb-etiket .p-tag) {
  background: #ffffff;
  border: 1px solid;
}
.sb-alan :deep(#sb-etiket .p-tag-success) {
  border-color: #15803d;
  color: #15803d;
}
.sb-alan :deep(#sb-etiket .p-tag-danger) {
  border-color: #b91c1c;
  color: #b91c1c;
}
.sb-alan :deep(#sb-etiket .p-tag-info) {
  border-color: #0369a1;
  color: #0369a1;
}
.sb-alan :deep(#sb-etiket .p-tag-warn) {
  border-color: #c2410c;
  color: #c2410c;
}
.sb-alan :deep(#sb-etiket .p-tag-secondary) {
  border-color: #374151;
  color: #374151;
}
/* KDU K8 "Kaydedilmedi" rozeti: #sb-etiket dışında (layout'un kendi öğesi) ama aynı warn stili */
.sb-alan :deep(.sb-kirli.p-tag) {
  background: #ffffff;
  border: 1px solid #c2410c;
  color: #c2410c;
}
.my-app-dark .sb-alan :deep(.sb-kirli.p-tag) {
  background: #111827;
  border-color: #fdba74;
  color: #fdba74;
}
.my-app-dark .sb-alan :deep(#sb-etiket .p-tag) {
  background: #111827;
}
.my-app-dark .sb-alan :deep(#sb-etiket .p-tag-success) {
  border-color: #86efac;
  color: #86efac;
}
.my-app-dark .sb-alan :deep(#sb-etiket .p-tag-danger) {
  border-color: #fca5a5;
  color: #fca5a5;
}
.my-app-dark .sb-alan :deep(#sb-etiket .p-tag-info) {
  border-color: #7dd3fc;
  color: #7dd3fc;
}
.my-app-dark .sb-alan :deep(#sb-etiket .p-tag-warn) {
  border-color: #fdba74;
  color: #fdba74;
}
.my-app-dark .sb-alan :deep(#sb-etiket .p-tag-secondary) {
  border-color: #d1d5db;
  color: #d1d5db;
}

/* Başlık düğmeleri + geri (karar 26, 27): silme (.p-button-danger) hariç aynı gri çerçeveli
   görünüm. Yardım düğmesi (text, çerçevesiz) bu seçicilere girmez. */
.sb-alan :deep(#sb-eylem .p-button-outlined:not(.p-button-danger)),
.sb-alan :deep(#sb-eylem .p-button-text:not(.p-button-danger)),
.sb-alan :deep(.sb-geri) {
  background: #ffffff;
  border: 1px solid #d1d5db;
  color: #374151;
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
}
.sb-alan :deep(#sb-eylem .p-button-outlined:not(.p-button-danger):hover),
.sb-alan :deep(#sb-eylem .p-button-text:not(.p-button-danger):hover),
.sb-alan :deep(.sb-geri:hover) {
  background: #f9fafb;
}
.my-app-dark .sb-alan :deep(#sb-eylem .p-button-outlined:not(.p-button-danger)),
.my-app-dark .sb-alan :deep(#sb-eylem .p-button-text:not(.p-button-danger)),
.my-app-dark .sb-alan :deep(.sb-geri) {
  background: #111827;
  border-color: #4b5563;
  color: #e5e7eb;
}
.my-app-dark .sb-alan :deep(#sb-eylem .p-button-outlined:not(.p-button-danger):hover),
.my-app-dark .sb-alan :deep(#sb-eylem .p-button-text:not(.p-button-danger):hover),
.my-app-dark .sb-alan :deep(.sb-geri:hover) {
  background: #1f2937;
}

/* Dolu ikincil düğmeler (karar 35): beyaz zemin + gri çerçeve (karar 26 ile aynı), yazı/ikon
   severity renginde kalır - birincil yuvadaki dolu düğmeler bu sarmalayıcının (.sb-ikincil)
   dışında kaldığı için etkilenmez. Renk seçicileri .p-button-<severity>'den daha özgül olduğu
   için taban kuraldaki varsayılan (secondary/yok) rengi kaynak sırası değil özgüllükle ezer. */
.sb-alan :deep(#sb-eylem .sb-ikincil .p-button:not(.p-button-outlined):not(.p-button-text)) {
  background: #ffffff;
  border: 1px solid #d1d5db;
  color: #374151;
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
}
.sb-alan :deep(#sb-eylem .sb-ikincil .p-button:not(.p-button-outlined):not(.p-button-text):hover) {
  background: #f9fafb;
}
.sb-alan :deep(#sb-eylem .sb-ikincil .p-button-info:not(.p-button-outlined):not(.p-button-text)) {
  color: #0369a1;
}
.sb-alan :deep(#sb-eylem .sb-ikincil .p-button-help:not(.p-button-outlined):not(.p-button-text)) {
  color: #7e22ce;
}
.sb-alan :deep(#sb-eylem .sb-ikincil .p-button-success:not(.p-button-outlined):not(.p-button-text)) {
  color: #15803d;
}
.sb-alan :deep(#sb-eylem .sb-ikincil .p-button-warn:not(.p-button-outlined):not(.p-button-text)) {
  color: #c2410c;
}
.sb-alan :deep(#sb-eylem .sb-ikincil .p-button-danger:not(.p-button-outlined):not(.p-button-text)) {
  color: #b91c1c;
}
.my-app-dark .sb-alan :deep(#sb-eylem .sb-ikincil .p-button:not(.p-button-outlined):not(.p-button-text)) {
  background: #111827;
  border-color: #4b5563;
  color: #e5e7eb;
}
.my-app-dark .sb-alan :deep(#sb-eylem .sb-ikincil .p-button:not(.p-button-outlined):not(.p-button-text):hover) {
  background: #1f2937;
}
.my-app-dark .sb-alan :deep(#sb-eylem .sb-ikincil .p-button-info:not(.p-button-outlined):not(.p-button-text)) {
  color: #7dd3fc;
}
.my-app-dark .sb-alan :deep(#sb-eylem .sb-ikincil .p-button-help:not(.p-button-outlined):not(.p-button-text)) {
  color: #d8b4fe;
}
.my-app-dark .sb-alan :deep(#sb-eylem .sb-ikincil .p-button-success:not(.p-button-outlined):not(.p-button-text)) {
  color: #86efac;
}
.my-app-dark .sb-alan :deep(#sb-eylem .sb-ikincil .p-button-warn:not(.p-button-outlined):not(.p-button-text)) {
  color: #fdba74;
}
.my-app-dark .sb-alan :deep(#sb-eylem .sb-ikincil .p-button-danger:not(.p-button-outlined):not(.p-button-text)) {
  color: #fca5a5;
}

/* Yardım (karar 17): 640px altında yazı gizlenir, ikon büyür. */
@media (max-width: 639px) {
  .sb-alan :deep(#sb-yardim .p-button-label) {
    display: none;
  }
  .sb-alan :deep(#sb-yardim .p-button-icon) {
    font-size: 1.25rem;
  }
}
</style>
